<div class="content-div">
  <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>

    <app-basic-button type="secondary" isIcon="true" size="medium" (click)="openHelp()">
      <i class="far fa-info-circle fs-16"></i>
    </app-basic-button>
  </div>

  <div class="top-bar">
    <span class="page-header">
      {{ 'users:usersfilter_ResourceType_11' | i18next : { defaultValue: 'Pause' } }}
    </span>
  </div>

<div class="margin-top-div-24"></div>

 <div class="content">

  <!-- Loading -->
  <div class="pause-loading" *ngIf="isLoading">
    <span class="loading"></span>
  </div>

  <!-- Messages -->
  <div *ngIf="errorMessage" class="pause-message pause-message--error">
    {{ errorMessage }}
  </div>
  <div *ngIf="successMessage" class="pause-message pause-message--success">
    {{ successMessage }}
  </div>

  <!-- READ-ONLY (no edit rights) -->
  <ng-container *ngIf="!canEdit && !isLoading">
    <div class="pause-card">
      <table class="pause-table">
        <tbody>
          <tr *ngFor="let p of pauseTypes">
            <td class="left" colspan="2">
              <span [innerHTML]="p.description"></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <!-- EDITABLE CARD -->
  <ng-container *ngIf="canEdit && !isLoading">
    <div class="pause-card">

      <!-- Header row -->
      <div class="pause-header-row">
        <div class="pause-header-col pause-header-col--reason">
          {{ 'users:usersfilter_ResourceType_11' | i18next : { defaultValue: 'Reason' } }}
        </div>
        <div class="pause-header-col pause-header-col--time" *ngIf="enableMaxTime">
          {{ 'users:pause_pausetime' | i18next : { defaultValue: 'Max time per day' } }}
        </div>
      </div>

      <!-- Rows container (sortable) -->
      <div
        class="pause-rows"
        cdkDropList
        (cdkDropListDropped)="drop($event)"
      >
        <div
          class="pause-row"
          *ngFor="let pause of pauseTypes; let i = index"
          cdkDrag
          cdkDragLockAxis="y"
        >
          <!-- drag handle -->
          <button
            type="button"
            class="pause-row__drag"
            cdkDragHandle
            aria-label="Reorder"
          >
               <img src="assets/Img/grip-dots-vertical.svg" class="icon-grip-dots" alt="Drag Handle" />
          </button>

          <!-- reason input -->
          <input
            type="text"
            class="pause-row__input pause-row__input--reason"
            [(ngModel)]="pause.description"
            (ngModelChange)="onDescriptionChange(pause)"
            [ngClass]="{ 'input-validation-error': pause.nameError }"
          />

          <!-- time input -->
          <input
            *ngIf="enableMaxTime"
            type="text"
            class="pause-row__input pause-row__input--time"
            [(ngModel)]="pause.maxPauseTimeString"
            (ngModelChange)="onPauseTimeChange(pause)"
            [ngClass]="{ 'input-validation-error': pause.timeError }"
            [attr.title]="pauseTimeTooltip"
          />

          <!-- delete button -->
         
           <app-basic-button type="decline" size="small" (click)="deletePause(pause)" class="delete-button-pause">
             <i class="fal fa-times"></i>
          </app-basic-button>
        </div>

        <!-- optional: empty state -->
        <div class="pause-empty" *ngIf="pauseTypes.length === 0">
          {{ 'users:no_pause_reasons' | i18next : { defaultValue: 'No pause reasons yet.' } }}
        </div>
      </div>

      <!-- Actions -->
      <div class="pause-actions">

         <app-basic-button type="secondary" size="small" (click)="addPause()">
           
            <i class="fal fa-plus plus-icon"></i>
            <span>
              {{ 'users:users_addPauseReason' | i18next : { defaultValue: 'Add pause reason' } }}
            </span>
          </app-basic-button>

        <div class="pause-actions__right">
 
           <app-basic-button type="secondary" size="small" (click)="undo()" [disabled]="undoDisabled || isSaving">
           {{ 'users:UndoChanges' | i18next : { defaultValue: 'Undo changes' } }}
          </app-basic-button>

          <app-basic-button type="primary" size="small" (click)="save()" [disabled]="saveDisabled || isSaving">
            {{ 'users:SaveChanges' | i18next : { defaultValue: 'Save changes' } }}
          </app-basic-button>

        </div>
      </div>

    </div>
  </ng-container>
</div>

</div>
